import {HttpClient} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {LocalStorageService} from '@app/core/services/local-storage.service';
import {ObjectUtils} from '@app/core/utils/object.utils';
import {environment} from '@environments/environment';
import {map, Observable, of} from 'rxjs';
import {ILanguage} from '../models/language.model';
import {ILocalizeProperty} from '../models/localizeProperty.model';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly _httpClient = inject(HttpClient);
  private readonly localStorageService = inject(LocalStorageService);

  private readonly getLanguagesUrl = `${environment.api.baseUrl}/${environment.api.config.getLanguages}`;
  private readonly getLocalizedProperties = `${environment.api.baseUrl}/${environment.api.config.getLocalizedProperties}`;
  private readonly setLanguageUrl = `${environment.api.baseUrl}/${environment.api.user.setLanguage}`;

  getLanguages(): Observable<ILanguage[]> {
    return this._httpClient.get<ILanguage[]>(this.getLanguagesUrl);
  }

  getLocalizeProperties(languageId: string): Observable<{[key: string]: string}> {
    const langId = languageId;
    let localizeProperties: {[key: string]: string} | null = null;
    localizeProperties = this.localStorageService.getItem(`LocalizedProperties_${languageId}`) as {
      [key: string]: string;
    };

    if (localizeProperties && !ObjectUtils.isEmpty(localizeProperties)) {
      return of(localizeProperties);
    } else {
      return this._httpClient.get<ILocalizeProperty[]>(`${this.getLocalizedProperties}/${langId}`).pipe(
        map(localizedProperties => {
          const parsedKeyValuePair = this.parseKeyValuePair(localizedProperties);
          this.localStorageService.setItem(`LocalizedProperties_${languageId}`, parsedKeyValuePair);
          return parsedKeyValuePair;
        })
      );
    }
  }

  setPreferredLanguage(languageId: string) {
    return this._httpClient.post(`${this.setLanguageUrl}/${languageId}`, null, {
      responseType: 'text',
    });
  }

  private parseKeyValuePair(localizedProperties: ILocalizeProperty[]): {
    [key: string]: string;
  } {
    const flattenedLocalizedProperties: {[key: string]: string} = {};

    localizedProperties.forEach(item => {
      flattenedLocalizedProperties[`${item.key}`] = item.value;
    });

    return flattenedLocalizedProperties;
  }
}
